import NotificationValidator from "Validators/Admin/Notification";
import { EditorState } from "draft-js";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import AdminRoutes from "Routes/Components/Admin";

import { transformEditorStateIntoData } from "Helpers/Util";

import { useFetch } from "Hooks/useFetch";
import { useFormSchema } from "Hooks/useFormSchema";
import useSegmentation from "Hooks/useSegmentation";

import Button from "Components/Admin/Buttons";
import DateValidity from "Components/Admin/DateValidity";
import FormWrapper from "Components/Admin/Form/FormWrapper";
import Input from "Components/Admin/Form/Input";
import Select from "Components/Admin/Form/Select";
import Section from "Components/Admin/Section";
import Segmentation from "Components/Admin/Segmentation";
import { TextEditor } from "Components/Admin/TextEditor";

import * as S from "./styles";

const level_options = [
  { value: "regular", label: "Regular" },
  { value: "toast", label: "Toast" },
  { value: "email", label: "E-mail" },
  { value: "popup", label: "Pop-up" },
];

const CreateNotification = () => {
  const navigate = useNavigate();
  const { fetchData, loading } = useFetch();
  const {
    setSegmentationConfig,
    stringifySegmentationState,
    resetSelectedStates,
  } = useSegmentation({ configs: { pageType: "create" } });

  const segmentationConfig = setSegmentationConfig({
    useAll: true,
  });

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const [selectedLevels, setSelectedLevels] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);

  const [notificationTypes, setNotificationTypes] = useState([]);
  const [selectedType, setSelectedType] = useState({});

  const methods = useFormSchema(NotificationValidator, {
    defaultValues: {
      start_at: null,
      finish_at: null,
    },
  });

  const { register, reset } = methods;

  useEffect(() => {
    getNotificationTypes();

    // eslint-disable-next-line
  }, []);

  const getNotificationTypes = async () => {
    const onSuccessCallback = (data) => {
      setNotificationTypes(
        data.map((notificationType) => ({
          // icon: notificationType.icon,
          value: notificationType.id,
          label: notificationType.display_name,
        })),
      );
    };

    await fetchData({
      method: "get",
      path: "/notifications/get-notification-types",
      onSuccessCallback,
    });
  };

  const submit = async (data) => {
    const successMessage = "Notificação criada com sucesso!";
    const onSuccessCallback = () => {
      setEditorState(null);
      setSelectedLevels([]);
      setSelectedType(null);
      setSelectedRoute(null);
      resetSelectedStates();
      reset();
    };

    data.description = transformEditorStateIntoData(editorState);

    await fetchData({
      method: "post",
      path: "/notifications/create-notification",
      body: {
        ...data,
        levels: JSON.stringify(selectedLevels.map((level) => level.value)),
        route: selectedRoute?.value,
        notification_type_id: selectedType?.value,
        ...stringifySegmentationState(),
      },
      successMessage,
      onSuccessCallback,
      config: {
        show_success_message: true,
      },
    });
  };

  return (
    <Section>
      <S.Wrapper>
        <FormWrapper {...methods} submit={submit}>
          <Input
            {...register("title")}
            type="text"
            label="Título"
            placeholder="Título"
            required
          />

          <TextEditor
            {...register("description")}
            editorState={editorState}
            setEditorState={setEditorState}
            key="description"
            label="Descrição"
            required
          />

          <DateValidity register={register} />

          <Input
            {...register("link")}
            type="text"
            label="Link"
            placeholder="Link"
          />

          <S.Type>
            <Select
              name="type"
              label="Categoria"
              placeholder={"Selecione uma Categoria"}
              options={notificationTypes}
              value={selectedType}
              onChange={setSelectedType}
            />

            <Button
              type="button"
              text="Criar Categoria"
              onClick={() => navigate(AdminRoutes.CreateNotificationType.path)}
              disabled={loading}
            />
          </S.Type>

          <Select
            name="levels"
            label="Níveis"
            placeholder={"Selecione os Níveis"}
            options={level_options}
            value={selectedLevels}
            onChange={setSelectedLevels}
            isMulti
            required
          />

          <Segmentation configs={segmentationConfig} />

          <Button type="submit" text="Criar" disabled={loading} />
        </FormWrapper>
      </S.Wrapper>
    </Section>
  );
};

export default CreateNotification;
